const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconForCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4844_19694",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 82
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000236511H81.9998V82H0V0.000236511Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4844_19694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.424 75.4639H4.86958C3.07263 75.4639 1.60144 73.9933 1.60144 72.1957V13.0409C1.60144 11.2433 3.07199 9.77277 4.86958 9.77277H70.2338C72.0312 9.77277 73.5019 11.244 73.5019 13.0409V53.9967",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9423 16.3086C15.6954 16.3086 13.8572 14.4702 13.8572 12.2233V5.6869C13.8572 3.43992 15.6954 1.60165 17.9423 1.60165C20.1891 1.60165 22.0275 3.44008 22.0275 5.6869V8.9552",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5518 16.3086C35.3048 16.3086 33.4666 14.4702 33.4666 12.2233V5.6869C33.4666 3.43992 35.3048 1.60165 37.5518 1.60165C39.7986 1.60165 41.6371 3.44008 41.6371 5.6869V8.9552",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1609 16.3086C54.9141 16.3086 53.0757 14.4702 53.0757 12.2233V5.6869C53.0757 3.43992 54.9141 1.60165 57.1609 1.60165C59.4078 1.60165 61.2462 3.44008 61.2462 5.6869V8.9552",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41833 22.8447H72.6848",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4105 31.0159V67.293",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4812 31.0159V67.293",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5518 31.0159V67.293",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6222 31.016V51.585",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6926 31.0161V44.208",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77197 38.2402H65.3313",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77197 49.1543H49.8175",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77197 60.0684H43.4703",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6586 80.5C73.8305 80.5 80.4997 73.8308 80.4997 65.659C80.4997 57.487 73.8305 50.8178 65.6586 50.8178C57.4867 50.8178 50.8176 57.487 50.8176 65.659C50.8176 73.8308 57.4866 80.5 65.6586 80.5Z",
    fill: "#FDD39E",
    stroke: "#5A045A",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9922 0.8275 0.6196)",
      fillOpacity: 1,
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5608 60.7569L60.7561 70.5615",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7561 60.7569L70.5608 70.5615",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForCancel);
export default __webpack_public_path__ + "static/media/icon-for-cancel.0e12c4a95ca6cfb6addbe9f347d3153c.svg";
export { ForwardRef as ReactComponent };